import { render, staticRenderFns } from "./IndustryAndProducts.vue?vue&type=template&id=6bdec1aa&scoped=true"
import script from "./IndustryAndProducts.vue?vue&type=script&lang=js"
export * from "./IndustryAndProducts.vue?vue&type=script&lang=js"
import style0 from "./IndustryAndProducts.vue?vue&type=style&index=0&id=6bdec1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdec1aa",
  null
  
)

export default component.exports